module.exports = __webpack_public_path__ + "static/img/shuz.4819085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuz.png
// module id = Dzwg
// module chunks = 0